import { ICustomElementViewModel, inject } from 'aurelia';
import { bindable } from 'aurelia';
import './ds-footer-section.scss';
import { Helper } from '../../extensions';

@inject(Helper)
export class DsFooterSection implements ICustomElementViewModel {
    @bindable title: string;
    @bindable links: any[] = [];
    environmentLink: string;

    constructor(private helper: Helper) {
        this.environmentLink = this.helper.environmentLink;
    }
}
